// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2497ed","colorSecondary":"#eaf5fe"};